import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BatteryIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V6.82H7.16V4.72H9.62V6.82H14.38V4.72H16.84V6.82H20.28V18.54ZM18.52 16.78V8.58H5.48V16.78H18.52ZM14.98 12L11.54 15.96H10.44L11.64 13.48H9.02L12.46 9.52H13.56L12.36 12H14.98Z" />
    </SvgIcon>
  );
});
